// extracted by css-extract-rspack-plugin
export default {"linksBlock":"_b4c97704","linksBlockHeader":"_ba5f719b","link":"_4adca5be"};